"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityBatchDeleteModel = exports.ActivityBatchUpdateHitsModel = exports.ActivityBatchUpdateLikesModel = exports.ActivityBatchUpdateModel = void 0;
var class_validator_1 = require("class-validator");
var ActivityBatchUpdateModel = /** @class */ (function () {
    function ActivityBatchUpdateModel() {
    }
    __decorate([
        class_validator_1.IsArray(),
        __metadata("design:type", Array)
    ], ActivityBatchUpdateModel.prototype, "ids", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], ActivityBatchUpdateModel.prototype, "newStatus", void 0);
    return ActivityBatchUpdateModel;
}());
exports.ActivityBatchUpdateModel = ActivityBatchUpdateModel;
var ActivityBatchUpdateLikesModel = /** @class */ (function () {
    function ActivityBatchUpdateLikesModel() {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ActivityBatchUpdateLikesModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], ActivityBatchUpdateLikesModel.prototype, "isLike", void 0);
    return ActivityBatchUpdateLikesModel;
}());
exports.ActivityBatchUpdateLikesModel = ActivityBatchUpdateLikesModel;
var ActivityBatchUpdateHitsModel = /** @class */ (function () {
    function ActivityBatchUpdateHitsModel() {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ActivityBatchUpdateHitsModel.prototype, "id", void 0);
    return ActivityBatchUpdateHitsModel;
}());
exports.ActivityBatchUpdateHitsModel = ActivityBatchUpdateHitsModel;
var ActivityBatchDeleteModel = /** @class */ (function () {
    function ActivityBatchDeleteModel() {
    }
    __decorate([
        class_validator_1.IsArray(),
        __metadata("design:type", Array)
    ], ActivityBatchDeleteModel.prototype, "ids", void 0);
    return ActivityBatchDeleteModel;
}());
exports.ActivityBatchDeleteModel = ActivityBatchDeleteModel;
//# sourceMappingURL=QueryParams.js.map